<template>
    <div class="menu-item-r">
        <div class="v-staff-info-wrap" v-loading="pageLoading">
            <el-form size="small" :model="inputVal" :rules="rules" class="v-from-wrap" ref="emailInfo">
                <!-- 个人信息 -->
                <div class="reg-title" v-if="fieldsLength[0] > 0">{{ $t('baseMess') }}</div>
                <el-row :gutter="30">
                <template v-for="item in configInputList">
                    <el-col :span="24" :key="item.id" v-if="personFieldsList.indexOf(item.keyword) > -1">
                    <template v-if="uploadFields.indexOf(item.keyword) == -1">
                        <template v-if="item.keyword == 'provinceId' || item.keyword == 'cityId'">
                        <el-form-item :label="item.name" :prop="item.keyword" v-if="codeDisabled()">
                            <!-- 省份 -->
                            <el-select
                            v-model="inputVal.provinceId"
                            @change="changeProvince"
                            :disabled="!item.editable"
                            v-if="item.keyword == 'provinceId'"
                            filterable>
                            <el-option v-for="c in pOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                            </el-select>
                            <!-- 城市 -->
                            <el-select 
                                v-model="inputVal.cityId" 
                                @change="changeCity" 
                                :disabled="!item.editable" 
                                v-if="item.keyword == 'cityId'" filterable>
                            <el-option v-for="c in cOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                            </el-select>
                        </el-form-item>
                        </template>
                        <template v-else>
                        <el-form-item :label="item.name" :prop="item.keyword">
                            <el-input
                                :placeholder="item.placeholder"
                                v-model.trim="inputVal[item.keyword]"
                                :disabled="!item.editable"
                                v-if="item.keyword == 'identificationNumber'"
                                >
                            </el-input>
                            <el-input
                                :placeholder="item.placeholder"
                                v-model.trim="inputVal[item.keyword]"
                                :disabled="!item.editable"
                                v-else-if="!item.canSelect && item.keyword !== 'validateCode'"
                                :maxlength="item.inputLength || 200">
                                <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode">{{
                                    inputVal.faxCode
                                }}</template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1"> - </template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1">{{inputVal.faxCode1}}</template>
                            </el-input>
                            <template v-else>
                            <!-- 国家 -->
                            <el-select
                                v-model="inputVal.countryId"
                                @change="changeCountry"
                                :disabled="!item.editable"
                                v-if="item.keyword == 'countryId'"
                                filterable
                            >
                                <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                            </el-select>
                            <!-- 性别 -->
                            <el-select
                                :placeholder="item.placeholder"
                                :disabled="!item.editable"
                                v-model="inputVal[item.keyword]"
                                v-if="fieldsList.indexOf(item.keyword) == -1 && item.keyword == 'gender'">
                                <el-option v-for="c in sexOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                            </el-select>
                            <!-- 证件类型 -->
                            <el-select
                                :placeholder="item.placeholder"
                                :disabled="!item.editable"
                                v-model="inputVal[item.keyword]"
                                v-if="fieldsList.indexOf(item.keyword) == -1 && item.keyword == 'idType'">
                                <el-option v-for="c in idTypeOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                            </el-select>
                            <!-- 社交媒体 -->
                            <el-select
                                :placeholder="item.placeholder"
                                :disabled="!item.editable"
                                v-model="inputVal[item.keyword]"
                                v-if="fieldsList.indexOf(item.keyword) == -1 && item.keyword == 'socialMedia'">
                                <el-option v-for="c in socialMediaOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                            </el-select>
                            </template>
                        </el-form-item>
                        </template>
                    </template>
                    <!-- 照片 -->
                    <template v-else>
                        <!-- 头像 -->
                        <el-form-item label-width="0" :prop="item.keyword"  v-if="item.keyword == 'headImage'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>{{ item.name }}
                            </h4>
                            <div>
                            <p>{{$t('Head Image1')}}<br/>{{$t('Head Image2')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-headerImg-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relative v-header-relative" v-loading="imgLoading" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.headImage" :src="inputVal.headImage" alt="" class="v-header-img" />
                                <i v-else class="iconfont iconshangchuan"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <el-upload action="" :http-request="loadImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span class="theme-color">{{ inputVal.headImage ? $t('Upload again') : $t('Upload picture') }}</span>
                                </el-upload>
                                <span class="theme-color pointer padding-l-12" @click="inputVal.headImage = ''" v-if="inputVal.headImage">{{ $t('del') }}</span>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>

                            <div class="v-headerImg-l">
                            <template v-if="language == 'zh'">
                                <img :src="headerImgCn"/>
                            </template>
                            <template v-else>
                                <img :src="headerImgEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.headImage" v-show="false"></el-input>
                        </el-form-item>
                        <!-- 个人工作证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>{{ item.name }}
                            </h4>
                            <div>
                            <p>{{$t('workPassTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadWorkPassImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.workPass" :src="inputVal.workPass" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadWorkPassImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">{{
                                        inputVal.workPass ? $t('Upload again') : $t('Upload picture')
                                    }}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.workPass = ''"
                                    v-if="inputVal.workPass">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>

                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="workPassCn"/>
                            </template>
                            <template v-else>
                                <img :src="workPassEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.workPass" v-show="false"></el-input>
                        </el-form-item>
                        <!-- 登记证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>《{{ item.name }}》
                            </h4>
                            <div>
                            <p>{{$t('registrationTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadRegistrationImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">{{
                                        inputVal.registration ? $t('Upload again') : $t('Upload picture')
                                    }}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.registration = ''"
                                    v-if="inputVal.registration">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>
                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="registrationCn"/>
                            </template>
                            <template v-else>
                                <img :src="registrationEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.registration" v-show="false"></el-input>
                        </el-form-item>
                    </template>
                    
                    </el-col>
                </template>
                </el-row>
                <!-- 公司信息 -->
                <div class="reg-title" v-if="fieldsLength[1] > 0">{{ $t('login2s.companyInfo') }}</div>
                <el-row :gutter="30">
                <template v-for="item in configInputList">
                    <el-col :span="uploadFields.indexOf(item.keyword) > -1 ? 24 : 24" :key="item.id" v-if="companyFieldsList.indexOf(item.keyword) > -1">
                    <template v-if="uploadFields.indexOf(item.keyword) > -1">
                        <!-- 登记证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>《{{ item.name }}》
                            </h4>
                            <div>
                            <p>{{$t('registrationTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadRegistrationImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">
                                        {{inputVal.registration ? $t('Upload again') : $t('Upload picture')}}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.registration = ''"
                                    v-if="inputVal.registration">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>
                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="registrationCn"/>
                            </template>
                            <template v-else>
                                <img :src="registrationEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.registration" v-show="false"></el-input>
                        </el-form-item>
                        <!-- 证件照 -->
                        <!-- 个人工作证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>{{ item.name }}
                            </h4>
                            <div>
                            <p>{{$t('workPassTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadWorkPassImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.workPass" :src="inputVal.workPass" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadWorkPassImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">
                                        {{inputVal.workPass ? $t('Upload again') : $t('Upload picture')}}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.workPass = ''"
                                    v-if="inputVal.workPass">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>

                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="workPassCn"/>
                            </template>
                            <template v-else>
                                <img :src="workPassEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.workPass" v-show="false"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item v-else :label="item.name" :prop="item.keyword">
                        <el-input
                        :placeholder="item.placeholder"
                        v-model.trim="inputVal[item.keyword]"
                        :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                        :disabled="!item.editable"
                        v-if="!item.canSelect"
                        :maxlength="item.inputLength || 200">
                        <el-select v-model="inputVal[item.keyword + '_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                        </el-select>
                        <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode">{{inputVal.faxCode}}</template>
                        <template slot="prepend" v-if="$config.form.phoneCodeFieldsQH.indexOf(item.keyword) > -1">{{inputVal.HQCode}}</template>
                        </el-input>
                        
                        <template v-else>
                        <!-- 总部国家 -->
                        <el-select v-model="inputVal.countryHeadQuater" :disabled="!item.editable" v-if="item.keyword == 'countryHeadQuater'" @change="changeCountryQH" filterable>
                            <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                        </el-select>
                        <!-- 公司所在国 -->
                        <el-select v-model="inputVal.corporateCountryName" :disabled="!item.editable" v-if="item.keyword == 'corporateCountryName'"  @change="changeCountryQH" filterable>
                            <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                        </el-select> 
                        </template>
                    </el-form-item>
                    </el-col>
                </template>
                </el-row>
                <!-- 海外总部公司信息 -->
                <div class="reg-title" v-if="fieldsLength[2] > 0">{{ $t('login2s.overseasCompanyInfo') }}</div>
                <el-row :gutter="30">
                <template v-for="item in configInputList">
                    <el-col :span="24" :key="item.id" v-if="overseasCompanyFieldsList.indexOf(item.keyword) > -1">
                    <template v-if="uploadFields.indexOf(item.keyword) > -1">
                        <!-- 登记证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>《{{ item.name }}》
                            </h4>
                            <div>
                            <p>{{$t('registrationTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadRegistrationImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">
                                        {{inputVal.registration ? $t('Upload again') : $t('Upload picture')}}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.registration = ''"
                                    v-if="inputVal.registration">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>
                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="registrationCn"/>
                            </template>
                            <template v-else>
                                <img :src="registrationCn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.registration" v-show="false"></el-input>
                        </el-form-item>
                        <!-- 证件照 -->
                        <!-- 个人工作证 -->
                        <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass'">
                        <div class="flex-start headerImg m-b-24">
                            <h4>
                            <template v-if="item.required">
                                <span class="v-xing">* </span>
                            </template>{{ item.name }}
                            </h4>
                            <div>
                            <p>{{$t('workPassTips')}}</p>
                            </div>
                        </div>
                        <div class="v-header div v-headerImg v-register-flex">
                            <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                            <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                                <el-upload
                                class="v-uploader"
                                :disabled="!item.editable"
                                :show-file-list="false"
                                action=""
                                :http-request="loadWorkPassImg"
                                accept="image/png, image/jpeg">
                                <img v-if="inputVal.workPass" :src="inputVal.workPass" alt="" class="v-header-img" />
                                <i v-else :class="['iconfont iconshangchuan', $route.params.type == 2 ? 'not-allowed' : '']"></i>
                                </el-upload>
                            </div>
                            <div class="font-size-14 text-right">
                                <div class="flex-end align-center v-btn-box" v-if="item.editable">
                                <div class="flex-start align-center v-btn-box" v-if="item.editable">
                                    <el-upload action="" :http-request="loadWorkPassImg" :show-file-list="false" accept="image/png, image/jpeg">
                                    <span :class="['theme-color padding-r-12', $route.params.type == 2 ? 'not-allowed' : '']">
                                        {{inputVal.workPass ? $t('Upload again') : $t('Upload picture')}}</span>
                                    </el-upload>
                                    <span
                                    :class="['theme-color pointer', $route.params.type == 2 ? 'not-allowed' : '']"
                                    @click="inputVal.workPass = ''"
                                    v-if="inputVal.workPass">{{ $t('del') }}</span>
                                </div>
                                </div>
                            </div>
                            <span class="v-up-tip v-head-up-tip"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                            </div>

                            <div class="v-workPass-l">
                            <template v-if="language == 'zh'">
                                <img :src="workPassCn"/>
                            </template>
                            <template v-else>
                                <img :src="workPassEn"/>
                            </template>
                            </div>
                        </div>
                        <el-input v-model="inputVal.workPass" v-show="false"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item v-else :label="item.name" :prop="item.keyword">
                        <el-input
                        :placeholder="item.placeholder"
                        v-model.trim="inputVal[item.keyword]"
                        :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                        :disabled="!item.editable"
                        v-if="!item.canSelect"
                        :maxlength="item.inputLength || 200">
                        <el-select v-model="inputVal[item.keyword + '_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                        </el-select>
                        <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode">{{inputVal.faxCode}}</template>
                        <template slot="prepend" v-if="$config.form.phoneCodeFieldsQH.indexOf(item.keyword) > -1">{{inputVal.HQCode}}</template>
                        </el-input>
                        
                        <template v-else>
                        <!-- 总部国家 -->
                        <el-select v-model="inputVal.countryHeadQuater" :disabled="!item.editable" v-if="item.keyword == 'countryHeadQuater'" @change="changeCountryQH" filterable>
                            <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                        </el-select>
                        <!-- 公司所在国 -->
                        <el-select v-model="inputVal.corporateCountryName" :disabled="!item.editable" v-if="item.keyword == 'corporateCountryName'" @change="changeCountryQH" filterable>
                            <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                        </el-select> 
                        </template>
                    </el-form-item>
                    </el-col>
                </template>
                </el-row>
                <div class="text-center" v-if="init">
                <el-button type="primary" :loading="loading" class="v-btn" @click="submit('emailInfo')">{{ $t('save') }}</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { validateEmail3, validateMobile3 } from '@/utils/validate'
import { getVisitor, getFetchList, completeVisitor,
  CheckValidation,
  GetValidationToken } from '@/api/index'
import headerImgCn from '@/assets/images/headerImgCn.png'
import workPassCn from '@/assets/images/workPassCn.png'
import registrationCn from '@/assets/images/registrationCn.png'
import headerImgEn from '@/assets/images/headerImgEn.png'
import workPassEn from '@/assets/images/workPassEn.png'
import registrationEn from '@/assets/images/registrationEn.png'
import registerMixin from '@/mixins/register.js'
import i18n from '@/utils/i18n'

export default {
  name: 'lAccountInfoEmail',
  mixins: [registerMixin],
  computed: {
    ...mapGetters(['language', 'subjectType', 'loginAccount', 'info'])
  },
  data() {
    return {
      certification: false,
      pageLoading: false,
      type: null, // 1个人信息，2公司信息
      isFace:false,
      headerImgCn: headerImgCn,
      workPassCn: workPassCn,
      registrationCn: registrationCn,
      headerImgEn: headerImgEn,
      workPassEn: workPassEn,
      registrationEn: registrationEn,
      imgLoading: false,
      imgLoadingWorkPass:false,
      imgLoadingRegistration:false,
      loading: false,
      fieldsList: ['countryName', 'provinceName', 'cityName'],
      uploadFields: ['headImage', 'registration', 'workPass'],
      personFieldsList: [
        'countryId', 'provinceId', 'cityId',
        'name', 'countryName','provinceName','cityName','email','mobile','identificationNumber',
        'idType','wechat','headImage','workPass','post'
      ],
      companyFieldsList: [
        'corporateName','telephone','fax','website','address','brand','registration'
      ],
      overseasCompanyFieldsList : [
        'nameHeadQuater','countryHeadQuater','addressHeadQuater',
        'telephoneHeadQuater','faxHeadQuater','emailHeadQuater','websiteHeadQuater'
      ],
      fieldsLength: [0, 0, 0],
      inputVal: {
        headImage: '',
        faxCode: '',  //国家码
        faxCode1: '', //城市码
        HQCode:'',    //总部国家码
        validateCode: '',
        website_http: 'http://',
        idType: ''
      },
      sexOption: [
        {
          label: i18n.t('sex[0]'),
          value: i18n.t('sex[0]')
        },
        {
          label: i18n.t('sex[1]'),
          value: i18n.t('sex[1]')
        }
      ],
      // 社交媒体字典
      socialMediaOption:i18n.t('select.socialMediaOptions'),
      // 证件类型字典
      idTypeOption:localStorage.getItem('language')=='en'?i18n.t('select.idTypeOptionsEN'):i18n.t('select.idTypeOptions'),
      //国家
      gOption: [],
      //省
      pOption: [],
      //市
      cOption: [],
      rules: {},
      configSwitch: {}, //配置开关
      configInputList: [],
      init: false,
      disabled: false,
      maxImgSize: 2 * 1024 * 1024
    }
  },
  components: {},
  watch: {
      '$route': {
          handler() {
              let path = this.$route.path
              if (path === '/profile') {
                  this.type = 1
              } else if (path === '/companyfile') {
                  this.type = 2
              }
              
          },
          immediate: true
      }
  },
  created() {
    /**
     * 判断用户语言和本地语言是否一致
     * 不一致的话提示，用户需要切换语言才能进入
     * 是否则返回上一页
     */
    let l = this.language == 'zh' ? 'cn' : this.language
    if (this.info && this.info.visitor && this.info.visitor.languageType != l) {
      let msg = ''
      let lang = ''
      if (l == 'en') {
        msg = this.$t('infoCn')
        lang = 'zh'
      } else {
        msg = this.$t('infoEn')
        lang = 'en'
      }
      this.$confirm(msg, this.$t('tips'), {
        type: 'warning',
        showCancelButton: false,
        showClose: false
      }).then(() => {
          this.$store.commit('SET_LANGUAGE', lang)
          window.location.reload()
        })
        .catch(() => {
          this.$router.go(-1)
        })
      return false
    }

    this.getPerson()
  },
  methods: {
    getPerson() {
        this.pageLoading = true
        this.inputInfo = null
        getVisitor({ userAccountId: this.info.visitor.id })
          .then(res => {
            if (res.data.data) {
              this.inputInfo = res.data.data || {}

              for (let item in this.inputInfo) {
                // 网址 回显
                if (this.$config.form.httpFields.indexOf(item) > -1) {
                    let info = this.inputInfo[item]
                    let httpValue = null
                    if (info && info.indexOf('http://') == 0) {
                        httpValue = info.substr(7)
                        this.$set(this.inputVal, item + '_http', 'http://')
                    } else if (info && info.indexOf('https://') == 0) {
                        httpValue = info.substr(8)
                        this.$set(this.inputVal, item + '_http', 'https://')
                    } else {
                        this.$set(this.inputVal, item + '_http', 'http://')
                    }
                    this.inputInfo[item] = httpValue || ''
                }
              }

              // 总部国家
              if(this.inputInfo.countryHeadQuaterId) {
                this.changeCountryQH(this.inputInfo.countryHeadQuaterId)
                this.$set(this.inputVal,'countryHeadQuater',this.inputInfo.countryHeadQuaterId)
              }
              // 公司所在国
              if(this.inputInfo.corporateCountryId) {
                this.$set(this.inputVal,'corporateCountryName',this.inputInfo.corporateCountryId)
              }
              // 根据国家选择证件类型
              if (this.inputInfo['countryId']) {
                this.changeCountry(this.inputInfo['countryId'])
              }
              // 检测往届数据邮箱是否正确
              if (this.inputInfo['email'] && !validateEmail3(this.inputInfo['email'])) {
                this.inputInfo['email'] = ''
              }
              // 检测往届数据手机号是否正确
              if (this.inputInfo['mobile'] && !validateMobile3(this.inputInfo['mobile'])) {
                this.inputInfo['mobile'] = ''
              }
              setTimeout(()=>{
                  this.$set(this.inputVal,'idType',this.inputInfo.idType)
              },1000)

            }
          }).catch(() => {
              this.pageLoading = false
          }).finally(() => {
            this.init0()
            this.getCountry()
          }) 
    },
    // 获取form字段
    loadConfig() {
      this.loading = true
      getFetchList()
        .then(res => {
          return res.data
        })
        .then(res => {
            if (!res.data) return
            /**
             * 给form赋值
             * 生成验证规则
             */
            this.itemConifg = {}
            let list = this.type === 1 ? res.data.formFieldList || [] : res.data.formFieldStepTwoList || []
            list.forEach((item) => {
                if (this.inputInfo[item.keyword]) {
                    this.$set(this.inputVal, item.keyword, this.inputInfo[item.keyword])

                    switch(item.keyword) {
                        case 'provinceName':
                            this.$set(this.inputVal, 'provinceId', this.inputInfo['provinceId'])
                            break
                        case 'countryName':
                            this.$set(this.inputVal, 'countryId', this.inputInfo['countryId'])
                            break
                        case 'cityName':
                            this.$set(this.inputVal, 'cityId', this.inputInfo['cityId'])
                            break
                        case 'telephoneHeadQuater':
                            if (this.inputVal.telephoneHeadQuater && this.inputVal.telephoneHeadQuater.indexOf('-') !== -1) {
                                let strA = this.inputVal.telephoneHeadQuater.split('-')
                                this.$set(this.inputVal, 'telephoneHeadQuater', strA[strA.length-1])
                            }
                            break
                        case 'telephone':
                            if (this.inputVal.telephone && this.inputVal.telephone.indexOf('-') !== -1) {
                                let strA = this.inputVal.telephone.split('-')
                                this.$set(this.inputVal, 'telephone', strA[strA.length-1])
                            }
                            break
                        case 'fax':
                            if (this.inputVal.fax && this.inputVal.fax.indexOf('-') !== -1) {
                                let strA = this.inputVal.fax.split('-')
                                this.$set(this.inputVal, 'fax', strA[strA.length-1])
                            }
                            break
                        case 'faxHeadQuater':
                            if (this.inputVal.faxHeadQuater && this.inputVal.faxHeadQuater.indexOf('-') !== -1) {
                                let strA = this.inputVal.faxHeadQuater.split('-')
                                this.$set(this.inputVal, 'faxHeadQuater', strA[strA.length-1])
                            }
                            break
                    }
                }

                switch (item.keyword) {
                    case 'provinceName':
                        if (!this.inputVal.provinceName) {
                            this.$set(this.inputVal, 'provinceId', '')
                        } else {
                            this.changeProvince(this.inputVal['provinceId'])
                        }
                        item.keyword='provinceId'
                        break
                    case 'countryName':
                        if (!this.inputVal.countryName) {
                            this.$set(this.inputVal, 'countryId', '')
                        } else {
                            this.changeCountry(this.inputVal['countryId'])
                        }
                        item.keyword='countryId'
                        break
                    case 'cityName':
                        if (!this.inputVal.cityName) {
                            this.$set(this.inputVal, 'cityId', '')
                        } else {
                            this.changeCity(this.inputVal['cityId'])
                        }
                        item.keyword='cityId'
                        break
                    case 'email':
                        break
                    default:
                        if (this.inputVal[item.keyword] == undefined || this.inputVal[item.keyword] == null) {
                            this.$set(this.inputVal, item.keyword, '')
                        }
                }
                if (item.keyword == 'mobile') {
                    item.inputLength = 11
                    if (this.inputVal.mobile) {
                        item.editable = false
                    }
                }
                if (item.keyword == 'email') {
                    if (this.inputVal.email) {
                        item.editable = false
                    }
                }

                // 必填条件
                if (item.required) {
                    let field = this.changeField(item.keyword) || item.keyword
                    
                    if (!this.rules[field]) {
                        this.$set(this.rules, field, [])
                    }

                    if (field == 'email' || field == 'emailHeadQuater') {
                        this.rules[field].push({
                            type: 'email',
                            required: true,
                            message: item.name + ' ' + this.$t('a olute or self-relative'),
                            trigger: 'change'
                        })
                    } else {
                        this.rules[field].push({
                            required: true,
                            message: item.name + ' ' + this.$t('common.required'),
                            trigger: 'change'
                        })
                    }
                }

                this.itemConifg[item.keyword] = item
            })
            
            this.configInputList = {...list}
            for(let k in this.configInputList) {
                let data = this.configInputList[k]
                if (this.personFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[0] ++ 
                } else if (this.companyFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[1] ++ 
                } else if (this.overseasCompanyFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[2] ++ 
                }
            }
            this.configSwitch = res.data.configSwitch
            this.isFace = res.data.configSwitch.face
        })
        .finally(() => {
          this.loading = false
          this.pageLoading = false
          this.init = true
        })
    },
    // 初始化0
    init0() {
      this.loadConfig()
    },
    checkID() {
        if(this.inputVal.countryId == 86) {
            GetValidationToken().then(restoken =>{
            if (restoken.data.Status === 'OK') {
                if(this.inputVal.name && this.inputVal.identificationNumber) {
                    CheckValidation({
                        Name: this.inputVal.name,
                        IDNum: this.inputVal.identificationNumber,
                        Code: '2021jjxbhxsz',
                        APPKey: restoken.data.AppTokenKey,
                        AppValue: restoken.data.AppTokenValue
                    }).then(valres=>{
                        if(valres.data.Status ==='OK'){
                            if(valres.data.result ==='false'){
                                this.$alert(this.$t('The name you entered is inconsistent with the ID number.'), this.$t('error'), {
                                    confirmButtonText: this.$t('ok'),
                                    closeOnClickModal: true,
                                    type: 'error',
                                    callback: () => {
                                        this.loading = false
                                    }
                                });
                                this.certification = false
                            } else {
                                this.certification = true
                            }
                        } else {
                            this.certification = false
                            this.$alert(valres.data.Msg, this.$t('error'), {
                                confirmButtonText: this.$t('ok'),
                                closeOnClickModal: true,
                                type: 'error',
                                callback: () => {
                                    this.loading = false
                                }
                            });
                        }
                    })
                }
                
            } else {
                this.loading = false
                this.$alert(this.$t('Token failed to get. Please get again'), this.$t('tips'), {
                confirmButtonText: this.$t('ok'),
                callback: () => {
                    GetValidationToken().then(restoken =>{
                    if (restoken.data.Status === 'OK') {
                        CheckValidation({
                            Name: this.inputVal.name,
                            IDNum: this.inputVal.identificationNumber,
                            Code: '2021jjxbhxsz',
                            APPKey: restoken.data.AppTokenKey,
                            AppValue: restoken.data.AppTokenValue
                        }).then(valres=>{
                        if(valres.data.Status ==='OK'){
                            if(valres.data.result ==='false'){
                                this.$alert(this.$t('The name you entered is inconsistent with the ID number.'), this.$t('error'), {
                                    confirmButtonText: this.$t('ok'),
                                    closeOnClickModal: true,
                                    type: 'error',
                                    callback: () => {
                                        this.loading = false
                                    }
                                });
                                this.certification = false
                            } else {
                                this.certification = true
                            }
                        } else {
                            this.certification = false
                            this.$alert(valres.data.Msg, this.$t('error'), {
                                confirmButtonText: this.$t('ok'),
                                closeOnClickModal: true,
                                type: 'error',
                                callback: () => {
                                    this.loading = false
                                }
                            });
                        }
                        })
                    } else {
                        this.certification = false
                        this.$alert(restoken.data.Msg, this.$t('error'), {
                            confirmButtonText: this.$t('ok'),
                            closeOnClickModal: true,
                            type: 'error'
                        });
                    }
                    })
                }
                });
            }
            })
        } else {
            this.loading = false
            this.certification = true
        }
    },
    // 提交
    submit(name) {
        this.loading = true
        if(this.inputVal.countryId == 86 && this.inputVal.name && this.inputVal.identificationNumber) {
            this.checkID()
        } else {
            this.certification = true
        }
        setTimeout(()=>{
            this.$refs[name].validate(valid => {
                if (valid) {
                    this.loading = true
                    if (this.inputVal.countryId != 86 || this.certification == true) {
                        if (this.isFace) {
                            this.inputVal.facePhotoUrl = this.inputVal.headImage
                            delete this.inputVal.headImage
                        }
                        let params = JSON.parse(JSON.stringify(this.inputVal))
                        params.countryCode = params.faxCode

                        if (params.faxCode != 86) {
                            params.validateCode = ''
                        }

                        // 公司所在国
                        if (params.corporateCountryName !== undefined ) {
                            params.corporateCountryId = params.corporateCountryName
                        }

                        // 总部国家
                        if (params.countryHeadQuater !== undefined) {
                            params.countryHeadQuaterId  = params.countryHeadQuater
                        }

                        for (let key in params) {
                            // 城市phoneCode
                            if (this.$config.form.cityPhoneCodeFields.indexOf(key) > -1 && params.faxCode1 && params[key]) {
                            params[key] = params.faxCode1 + '-' + params[key]
                            }
                            //总部国家电话/传真
                            if (this.$config.form.phoneCodeFieldsQH.indexOf(key) > -1 && params.HQCode && params[key]) {
                            params[key] = params.HQCode + '-' + params[key]
                            }

                            // 网址
                            if (this.$config.form.httpFields.indexOf(key) > -1 && params[key]) {
                            params[key] = params[key + '_http'] + params[key]
                            }
                        }
                        
                        params = this.getSumbitParams(params, this.itemConifg)
                        params.registerState = this.type === 1 ? 4 : 1

                        completeVisitor(params)
                            .then(res => {
                            if (res.data.code === 1000) {
                                this.$notify.success(this.$t('Update successfully'))
                                let info = this.info
                                info.visitor.email = res.data.data.email || ''
                                info.visitor.cardNumber = res.data.data.cardNumber || ''
                                info.visitor.name = res.data.data.name || ''
                                this.$store.commit('SET_INFO', info)
                            }
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    }
                } else {
                    this.loading = false
                    return false
                }
            })
        },1000)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-staff-info-wrap {
    margin: 30px auto;
    background: $color-white;
    overflow: hidden;
}

.v-btn{
  width: 544px;
  font-size:16px;
  margin:12px auto 60px;
}

.v-up-tip{
  display:block;
  margin:4px 0;
  margin-top: -2px;
  color:$color-black-25;
}

.v-load-img-box{
  margin:50px 0 32px;
}
.v-box{
  height: 32px;
}
.v-img-border .v-header .relative{
  border-radius:0;
}
.v-img-border .v-header .v-header-img{
  border-radius:0;
}
.v-bot{
  width: 544px
  margin 0 auto
}
.headerImg{
  h4{
    line-height: 25px;
    margin-right: 20px;
    font-size 16px
  }
  p{
    line-height 25px
    font-size 14px
    color: $color-black-35;  
  }
}
.v-header-relative{
    width 150px
    height 150px
}
.el-icon-warning{
  margin-right 4px
  color:$color-headImg-tips
}
</style>
